import request from '@/middleware/request'

const getVoiceSession = data => {
  return request({
    url: '/realtime/voice_session',
    method: 'post',
    data
  })
}

const getChatSession = data => {
  return request({
    url: '/realtime/chat_session',
    method: 'post',
    data
  })
}

const getVoiceSessionSuccess = data => {
  return request({
    url: '/realtime/voice_session_success',
    method: 'post',
    data
  })
}

const getVoiceCall = data => {
  return request({
    url: '/realtime/voice_call',
    method: 'post',
    data
  })
}
const getVoiceAnsweredCall = data => {
  return request({
    url: '/realtime/voice_answered_call',
    method: 'post',
    data
  })
}

const getChatSessionSuccess = data => {
  return request({
    url: '/realtime/chat_session_success',
    method: 'post',
    data
  })
}

const getTagCloud = () => {
  return request({
    url: '/realtime/tag_cloud',
    method: 'get'
  })
}

const getConcurrent = data => {
  return request({
    url: '/realtime/concurrent',
    method: 'post',
    data
  })
}

export default {
  getVoiceSession,
  getVoiceSessionSuccess,
  getVoiceCall,
  getVoiceAnsweredCall,
  getChatSession,
  getChatSessionSuccess,
  getTagCloud,
  getConcurrent
}
